import axios from 'axios';

import { clsAPIurl } from '../config';

export async function login(credentials) {
	try {
		// Realiza la solicitud POST con las credenciales
		const response = await axios({
			method: 'post',
			url: `${clsAPIurl}/login`,
			data: credentials,
			headers: {
				Accept: 'application/json, text/plain, */*',
				'Content-Type': 'application/json'
			}
		});

		// Retorna respuesta de la solicitud
		return response.data;
	} catch (error) {
		// Maneja el error y lo lanza para ser gestionado por el llamador
		console.error('Error during login:', error);
		throw new Error('Login failed');
	}
}
